export const noStateFieldLocales = [
  'de',
  'uk',
  'eu',
  'fr',
  'ch',
  'se',
  'no',
  'dk',
  'it',
  'nl',
  'at',
];
